import React from 'react';

import RoundedProfilePhoto from '../RoundedProfilePhoto/RoundedProfilePhoto';
import SocialLinks from '../SocialLinks/SocialLinks';
import Particles from 'particlesjs/dist/particles.min';
import TextCarousel from '../TextCarousel/TextCarousel';

import './Cover.css';
import Logo from "../Logo/Logo";


class Cover extends React.Component {
    componentDidMount() {
        Particles.init({
            selector: '.particles-background',
            color: ['#1E90FF', '#ffffff'],
            speed: .2,
            connectParticles: true,
            maxParticles: 150,
            minDistance: 80
        });
    }

    render() {
        return (
            <React.Fragment>
                <canvas className="particles-background"/>
                <section id="cover">

                    <RoundedProfilePhoto alt="Foto de Perfil de Lautaro Aguirre"/>
                    <div>
                        <ul>
                            <li><h1>Hi there!</h1></li>
                            <li><h1>I'm <strong>Lautaro Aguirre</strong>, a pragmatic <strong>Software Engineer</strong></h1></li>

                            <li><h1>I
                                <TextCarousel texts={[
                                    'love to innovate',
                                    'am a self-taught engineer',
                                    'am always learning',
                                    'am a problem solver',
                                    'an a content creator',
                                    'take care of details',
                                    'love to create things',
                                    'write elegant code for humans',
                                ]}/>
                            </h1></li>

                            <li><span>Student of B.Sc in Information Systems Engineering (Ing. en Sistemas) at UTN FRBA</span></li>
                            <li><Logo/></li>
                        </ul>
                        <SocialLinks/>
                    </div>

                </section>
            </React.Fragment>

        );
    }
}

export default Cover;